import { Page } from '~/models/PaginatedItems'
import { Spot2 } from '~/models/Spot'
import { BasePaginatedMemoryCache } from '~/passporter-services/basePaginatedMemoryCache'

export class SpotRecommendationsCache extends BasePaginatedMemoryCache<Spot2> {
	public setItineraryPage(
		itineraryId: string,
		spotPage: Page<Spot2>,
		page: number,
		pageSize: number
	) {
		this.setPage(itineraryId, { ...spotPage, page, pageSize })
	}

	public getItineraryPage(
		itineraryId: string,
		page: number,
		pageSize: number
	): Page<Spot2> | undefined {
		return this.getPage(itineraryId, page, pageSize)
	}

	public deleteItineraryPages(itineraryId: string) {
		this.delete(itineraryId)
	}
}
